import {BehaviorSubject} from 'rxjs';

export class AppSubject {

  private static readonly decreeCircular = new BehaviorSubject<string>('');
  private static readonly reload = new BehaviorSubject<string>('');
  private static readonly addCTS = new BehaviorSubject<string>('');

  static getDecreeCircular(): BehaviorSubject<string> {
    return this.decreeCircular;
  }

  static setDecreeCircular(decreeCircular: string): void {
    this.decreeCircular.next(decreeCircular);
  }
  static getReloadData(): BehaviorSubject<string> {
    return this.reload;
  }

  static setReloadData(decreeCircular: string): void {
    this.reload.next(decreeCircular);
  }

}
